import { createGlobalStyle } from "styled-components"

export default createGlobalStyle`
  @keyframes flyingTitle {
    100% {
      transform: translate(-100vw, -50%);
    }
  }
`
